import trunkBack from '@legit-health/svg-images/images/apasi-global-perspectives/armsAndHandsBack.svg';
import trunkFront from '@legit-health/svg-images/images/apasi-global-perspectives/armsAndHandsFront.svg';
import closeUpArms from '@legit-health/svg-images/images/apasi-global-perspectives/closeUpArms.svg';
import closeUpHead from '@legit-health/svg-images/images/apasi-global-perspectives/closeUpHead.svg';
import closeUpLegs from '@legit-health/svg-images/images/apasi-global-perspectives/closeUpLegs.svg';
import closeUpTrunk from '@legit-health/svg-images/images/apasi-global-perspectives/closeUpTrunk.svg';
import footBack from '@legit-health/svg-images/images/apasi-global-perspectives/footBack.svg';
import headBack from '@legit-health/svg-images/images/apasi-global-perspectives/headBack.svg';
import headFront from '@legit-health/svg-images/images/apasi-global-perspectives/headFront.svg';
import legsAndFootBack from '@legit-health/svg-images/images/apasi-global-perspectives/legsAndFootBack.svg';
import legsAndFootFront from '@legit-health/svg-images/images/apasi-global-perspectives/legsAndFootFront.svg';

export const BODY_PARTS = {
  headFront: {
    code: 'headFront',
    image: headFront,
    validationCode: 'head'
  },
  headBack: {
    code: 'headBack',
    image: headBack,
    validationCode: null
  },
  trunkFront: {
    code: 'trunkFront',
    image: trunkFront,
    validationCode: 'arms'
  },
  trunkBack: {
    code: 'trunkBack',
    image: trunkBack,
    validationCode: 'arms'
  },
  legsAndFeetFront: {
    code: 'legsAndFeetFront',
    image: legsAndFootFront,
    validationCode: 'legs'
  },
  legsAndFeetBack: {
    code: 'legsAndFeetBack',
    image: legsAndFootBack,
    validationCode: 'legs'
  },
  feetBack: {
    code: 'feetBack',
    image: footBack,
    validationCode: null
  },
  closeUpHead: {
    code: 'closeUpHead',
    image: closeUpHead,
    validationCode: null
  },
  closeUpTrunk: {
    code: 'closeUpTrunk',
    image: closeUpTrunk,
    validationCode: null
  },
  closeUpArms: {
    code: 'closeUpArms',
    image: closeUpArms,
    validationCode: null
  },
  closeUpLegs: {
    code: 'closeUpLegs',
    image: closeUpLegs,
    validationCode: null
  }
} as const;

export const BODY_PARTS_ARRAY = [
  'feetBack',
  'headFront',
  'headBack',
  'trunkFront',
  'trunkBack',
  'legsAndFeetFront',
  'legsAndFeetBack',
  'closeUpHead',
  'closeUpTrunk',
  'closeUpArms',
  'closeUpLegs'
] as const;
